import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { quotationChildrenRoutes } from './quotationChildrenRoutes';
import path from 'path';

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));
const EndorsementPage = lazy(() => import('../../pages/quotation').then(module => ({ default: module.SavedQuotes })));

interface RouteItem {
  path: string;
  element: JSX.Element;
}

const quotationRoutes = {
  path: '/cotizador',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    ...quotationChildrenRoutes.map(({ path, element }: RouteItem) => ({
      path,
      element,
    })),
  ],
};

export default quotationRoutes;
